import { useNavigate } from "react-router";

function toTitleCaseFromId(value) {
    if (typeof value !== "string") return "";
    return value
        .trim()
        .replace(/[_-]+/g, " ")
        .split(/\s+/g)
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
}

export default function ProblemSelector({ problemName, concepts, difficulty, displayName }) {
    const navigate = useNavigate();
    const difficultyClass =
        difficulty === "Easy"
            ? "problem-selector__difficulty--easy"
            : difficulty === "Medium"
                ? "problem-selector__difficulty--medium"
                : "problem-selector__difficulty--hard";

    const label = displayName ?? toTitleCaseFromId(problemName);

    return (
        <div
            className="problem-selector"
            onClick={() => {
                navigate(`/chat/${problemName}`);
            }}
        >
            <div className="problem-selector__name">{label}</div>
            <div className="problem-selector__concepts">{concepts}</div>
            <div className={`problem-selector__difficulty ${difficultyClass}`}>{difficulty}</div>
        </div>
    );
}